<template>
    <div class="home">
        <div class="slider-wrapper">
            <slider animation="fade" height="379px">
                <slider-item v-for="(banner,index) in banners" :key="index">
                    <div class="banner-content">
                        <div class="banner-text">
                            <div class="topic">{{banner.mcfTopic.topic}}</div>
                            <div class="reward">
                                <!--그룹 금액-->{{$t("home.code001")}} 
                                <!--￦-->{{$t("home.code002")}}
                                {{banner.mcfTopic.maxAmount|numberFormat}}
                            </div>
                            <div class="max-count"> 
                                
                                <template v-if="localeLang == 'en'">
                                    <!--그룹 정원-->{{$t("home.code003")}} 
                                    {{banner.mcfTopic.maxCount|numberFormat}} 

                                    <template v-if="(banner.mcfTopic.maxCount|numberFormat) >= 2">
                                        Persons
                                    </template>
                                    <template v-else>
                                        Person
                                    </template>

                                </template>
                                <template v-else>
                                    <!--그룹 정원-->{{$t("home.code003")}} 
                                    {{banner.mcfTopic.maxCount|numberFormat}}명
                                </template>
                                
                                <router-link :to="{name:'FAQ'}" class='guide'></router-link>  
                            </div> 
                            <div class='container'>
                              <router-link :to="{name:'JobDetail', params:{uuid:banner.mcfTopic.uuid}}" class="link-button"><!--참가하기-->{{$t("home.code004")}}</router-link>
                              <div class="participant">
                                
                                <template v-if="localeLang == 'en'">
                                    {{(banner.mcfTopic.countOfGroupReady + banner.mcfTopic.countOfGroupStandby + banner.mcfTopic.countOfGroupProgress + banner.mcfTopic.countOfGroupCompletion)|numberFormat}}
                                    <template v-if="((banner.mcfTopic.countOfGroupReady + banner.mcfTopic.countOfGroupStandby + banner.mcfTopic.countOfGroupProgress + banner.mcfTopic.countOfGroupCompletion)|numberFormat) >= 2">
                                        <!--누적 그룹-->{{$t("home.code0052")}} 
                                    </template>
                                    <template v-else>
                                        <!--누적 그룹-->{{$t("home.code0051")}} 
                                    </template>
                                </template>
                                <template v-else>
                                    <!--누적 그룹-->{{$t("home.code005")}} 
                                    {{(banner.mcfTopic.countOfGroupReady + banner.mcfTopic.countOfGroupStandby + banner.mcfTopic.countOfGroupProgress + banner.mcfTopic.countOfGroupCompletion)|numberFormat}}
                                </template>
                                
                              </div>
                            </div>
                        </div>
                        <img :src="banner.mcfTopic.mainBannerImageUrl">
                    </div>
                </slider-item>
            </slider>
        </div>
        
        <div class="banner-audio-font" @click="goPageAudio" :style="localeImg001"></div>
        
        <div class="content-container">
            <div class="jobs">
                <div class="heading"><!--일거리 목록-->{{$t("home.code006")}}</div>
                <ul class="job-list">
                    <li v-for="job in jobs" :key="job.uuid">
                        <div class="image-container">
                            <img :src="job.mcfTopic.thumbnailUrl">
                        </div>
                        <div class="info">
                            <div class="title">{{job.mcfTopic.topic}}</div>
                            <div class="description">
                                
                                <!--{{job.mcfTopic.topicType==1?'#'+job.mcfTopic.displayVideoStyleType+'&nbsp;&nbsp;#'+job.mcfTopic.displayTimeLimit:job.mcfTopic.displayTopicType}}-->
                                <template v-if="job.mcfTopic.topicType == 1">
                                    <template v-if="+job.mcfTopic.videoStyleType == 1">#{{$t("displayVideoStyleType.code001")}}</template>
                                    <template v-else-if="+job.mcfTopic.videoStyleType == 2">#{{$t("displayVideoStyleType.code002")}}</template>
                                    <template v-else-if="+job.mcfTopic.videoStyleType == 3">#{{$t("displayVideoStyleType.code003")}}</template>
                                    <template v-else-if="+job.mcfTopic.videoStyleType == 4">#{{$t("displayVideoStyleType.code004")}}</template>
                                    <template v-else>{{+job.mcfTopic.displayVideoStyleType}}</template>
                                    &nbsp;&nbsp;
                                    <template v-if="job.mcfTopic.timeLimit == 'f1s'">#{{$t("displayTimeLimit.code001")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f2s'">#{{$t("displayTimeLimit.code002")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f3s'">#{{$t("displayTimeLimit.code003")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f4s'">#{{$t("displayTimeLimit.code004")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f5s'">#{{$t("displayTimeLimit.code005")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f10s'">#{{$t("displayTimeLimit.code006")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f30s'">#{{$t("displayTimeLimit.code007")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == 'f1m'">#{{$t("displayTimeLimit.code008")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '1s'">#{{$t("displayTimeLimit.code009")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '2s'">#{{$t("displayTimeLimit.code010")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '5s'">#{{$t("displayTimeLimit.code011")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '10s'">#{{$t("displayTimeLimit.code012")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '30s'">#{{$t("displayTimeLimit.code013")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '1m'">#{{$t("displayTimeLimit.code014")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '3m'">#{{$t("displayTimeLimit.code015")}}</template>
                                    <template v-else-if="job.mcfTopic.timeLimit == '5m'">#{{$t("displayTimeLimit.code016")}}</template>
                                    <template v-else>{{job.mcfTopic.displayTimeLimit}}</template>
                                </template>
                                <template v-else>
                                    <!--{{job.mcfTopic.displayTopicType}}-->
                                    {{$t("displayTopicType.code002")}}
                                </template>
                                
                            </div>
                            <div class="container">
                              <div class="label first"><img src="../assets/images/common/icon-amount.png"> <!--금액-->{{$t("home.code001")}}</div>
                              <div class="reward"><span><!--￦-->{{$t("home.code002")}}</span>{{job.mcfTopic.maxAmount|numberFormat}}</div>
                            </div>
                            <div class="container">
                              <div class="label"><img src="../assets/images/common/icon-headcount.png"> <!--정원-->{{$t("home.code003")}}</div>
                              <div class="personal">{{job.mcfTopic.maxCount|numberFormat}}</div>
                            </div>
                        </div>
                        <div class="button">
                            <router-link :to="{name:'JobDetail', params:{uuid:job.mcfTopic.uuid}}" class="entry-button"><!--참가하기-->{{$t("home.code004")}}</router-link>
                            <img src="../assets/images/home/line.png">
                            <a v-on:click='openStatusLayer(job.mcfTopic.uuid)' class="entry-button"><!--경쟁 현황 보기-->{{$t("home.code007")}}</a>
                        </div>
                    </li>
                    <li v-on:click="more()">
                        <div><img :src="localeImg002"></div>
                    </li>
                </ul>
            </div>
        </div>
 
        <CompetitionBoard ref="board"></CompetitionBoard>

        <div id="popup">
            <div id="popupImage">
                <img :src="localeImg003" usemap="#popup">
                <map name="popup">
                    <area shape="rect" coords="0, 570, 220, 640" @click="closePopup(1)">
                    <area shape="rect" coords="260, 570, 480, 640" @click="closePopup(0)">
                </map>
            </div>
            <div id="black-screen"></div> 
        </div>

        <div id="popup2">
            <div id="popupImage2">
                <img :src="popupImg" @click="closePopup2()">
            </div>
            <div id="black-screen2" @click="closePopup2()"></div> 
        </div>

        
    </div>
</template> 
<script>
    import {Slider, SliderItem} from 'vue-easy-slider'
    import CompetitionBoard from './job/CompetitionBoard.vue'

    export default {
        mounted: function() { 
            require('../assets/js/jquery.min.js') 
            
            if (this.localeLang == 'en') {
                //this.getPopup() 
            } else {
                this.getPopup()
                //this.getPopup2()
            }
            
            this.getHomeBanners()
            this.getHomeJobs()

			// Event snippet for 멸치패밀리사이트 유입 conversion page
			this.$gtag.event('conversion', {'send_to': 'AW-811465306/iIoYCI7w-80BENr094ID'})
        },
        props: {
            castingn: Boolean 
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            localeLang() { return this.$i18n.t('lang') }, 
            localeImg001() {
                var imgSrc = require('@/assets/locale/ko/images/banner-audio-font.png')
                var imgSrcEn = require('@/assets/locale/en/images/banner-audio-font.png')
                if (this.localeLang == "en") { imgSrc = imgSrcEn }
                return { background: 'url(\''+ imgSrc + '\') no-repeat center' }
            },
            localeImg002() {
                var imgSrc = require('@/assets/locale/ko/images/icon-more.png')
                var imgSrcEn = require('@/assets/locale/en/images/icon-more.png')
                if (this.localeLang == "en") { imgSrc = imgSrcEn }
                return imgSrc
            },
            localeImg003() {
                var imgSrc = require('@/assets/locale/ko/images/popup-200904-2.jpg')
                var imgSrcEn = require('@/assets/locale/en/images/popup-190805-4.jpg')
                if (this.localeLang == "en") { imgSrc = imgSrcEn }
                return imgSrc
            },
            popupImg() { return require('@/assets/images/popup/photo_2020-11-13_18-19-13.jpg') }
        },
        created: function () {
            this.banners = []
            if (this.castingn == true) {
                localStorage.setItem('isCastingn', this.castingn) 
            } 
        },
        components: {
            Slider,
            SliderItem,
            CompetitionBoard,
        },
        data: function () {
            return {
                banners: [],
                jobs: [],
            }
        },
        methods: {
            more: function() {
                this.$router.push({path: "/jobs"})
            },
            async getHomeBanners() {
                let response = await this.$api.getHomeBanners()
                this.banners = response.data
            },
            async getHomeJobs() {
                let response = await this.$api.getHomeJobs()
                this.jobs = response.data
            },
            goPageAudio() {
                this.$router.push({path: "/audio"})
            },
            openStatusLayer(uuid) {
                this.$refs.board.openStatusLayer(uuid)
            },
            getPopup() {
                const yyyymmdd = this.getDate();
                const closePopup = localStorage.getItem("closePopup");
                
                console.log("getPopup - yyyymmdd: " +yyyymmdd);
                console.log("getPopup - closePopup: " +closePopup);

                if (yyyymmdd != closePopup) $("#popup").show();
            },
            getPopup2() {
                $("#popup2").show();
            },
            closePopup(type) {
                if (type == 1) {
                    const yyyymmdd = this.getDate();
                    console.log("closePopup - yyyymmdd: " +yyyymmdd);
                    localStorage.setItem('closePopup', yyyymmdd);
                }
                $("#popup").hide();
            },
            closePopup2() {
                $("#popup2").hide();
            },
            getDate() {
                const date = new Date();
                const yyyymmdd = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
                console.log("getDate - yyyymmdd: " +yyyymmdd);
                return yyyymmdd;
            }

        }
    }
</script>
<style>
    div.home .indi-center {
        margin-left: -390px;
    }

    div.home .slider-indicator-icon {
        border: 1px solid #cccccc;
        width: 15px;
        height: 15px;
        margin: 0.15rem;
    }

    div.home .slider-icon {
        width: 30px;
        height: 30px;
    }
</style>
<style scoped lang="scss">
    div.home {

        div.slide-wrapper {
            position: relative;
        }
        div.banner-content {
            position: relative;
            width: 100%;
            height: 379px;
            overflow: hidden;

            div.banner-text {
                position: absolute;
                display: inline-block;
                width: 800px;
                margin-left: -450px;
                top: 68px;
                left: 50%;
                z-index: 10;

                div.topic {
                    font-size: 46px;
                    color: #ffffff;
                }
                div.reward {
                    font-size: 46px;
                    color: #ffffff;
                    font-weight: bold;
                    margin-top: 10px;
                }
                div.max-count {
                    margin-top: 10px;
                    vertical-align: middle;
                    font-size: 18px;
                    color: #ffffff;
                   
                    a.guide {
                        margin-left: 5px;
                        margin-bottom: 4px;
                        width: 20px;
                        height: 20px;
                        vertical-align: middle; 
                        display: inline-block;
                        background: url('../assets/images/common/icon-question.png') center center no-repeat;
                        background-size: 20px 20px;
                    }
                }
                div.container {
                  display: flex;
                  align-items: center;
                  margin-top: 20px;
                }
                a.link-button {
                    background: #0099ff;
                    color: #ffffff;
                    padding: 12px 30px;
                }
                a:hover {
                    background: #0073bf;
                }
                div.participant {
                    padding: 12px 10px;
                    font-size: 14px;
                    color: #0099ff;
                }
            }

            img {
                position: absolute;
                left: 50%;
                margin-left: -980px;
            }
        }

        div.banner-audio-font {
            position: relative;
            height: 95px;
            margin-top: 10px; 
            margin-bottom: 75px; 
            margin-left: -40px;
            cursor: pointer;
        }

        div.content-container {
            width: 1080px;
            margin: 0 auto;
            margin-bottom: 80px;
        }

        div.jobs {
            margin-top: 57px;
            position: relative;

            div.heading {
                font-size: 28px;
                color: #434158;
                text-align: center;
            }

            a.button-more {
                font-size: 14px;
                color: #0099ff;
                border: 2px solid #0099ff;
                padding: 8px 28px;
                position: absolute;
                top: 0;
                right: 1%;
            }

            ul.job-list {
                padding-left: 30px;
                margin-top: 25px;

                li {
                    position: relative;
                    display: inline-block;
                    width: 231px;
                    margin: 0px 1% 80px 1%;
                    font-size: 0;
                    vertical-align: top;
                    border: 2px solid #F0F0F0;

                    div.image-container {
                        width: 100%;
                        img {
                            display: block;
                            width: 231px;
                            height: 130px;
                        }
                    }

                    div.info {
                        padding: 23px 12px 0 12px;
                        min-height: 140px;
                        border-top: none;
                        position: relative;
                        
                        img {
                            vertical-align: middle;
                            margin-bottom: 2px;
                        }

                        div.title {
                            font-size: 17px;
                            line-height: 120%;
                            min-height: 40px;
                            color: #1665b6;
                        }

                        div.description {
                            margin-top: 8px;
                            font-size: 14px; 
                            color: #666666;
                        }

                        div.container {
                          display: flex;
                          justify-content: space-between;
                        }

                        div.label {
                            text-align: left;
                            font-size: 12px;
                            color: #666666;
                            &.first {
                              margin-top: 17px;
                            }
                        }

                        div.reward {
                            margin-top: 18px;
                            font-size: 22px;
                            color: #0099ff;
                            text-align: right;

                            span {
                                font-size: 12px;
                                color: #666666;
                            }
                        }

                        div.personal {
                            margin-top: 5px;
                            font-size: 16px;
                            color: #666666;
                            margin-bottom: 18px;
                            span {
                                font-size: 12px;
                            }
                        }
                    }

                    .button {
                        a.entry-button {
                            display: inline-block;
                            width: 115px;
                            padding: 14px 0 13px 0;
                            text-align: center;
                            font-size: 13px;
                            color: #ffffff;
                            background: #0099ff;
                            vertical-align: middle;
                        }

                        a:hover {
                            background: #0073bf;
                        }

                        img {
                            vertical-align: middle;
                        }
                    }

                    div.status {
                      margin-top: 32px;
                      text-align: center;
                      color: #999999;
                      a {
                        font-size: 14px;
                      }
                      div.divide {
                        height: 1px;
                        width: 84px;
                        margin: 3px auto 0;
                        background-color: #999999;
                      }
                    }
                }

                li:last-child {
                    height: 339px;
                    text-align: center;
                    cursor: pointer;
                    
                    img {
                        margin-top: 130px; 
                    }
                }
            }
        }

        #popup {
            z-index: 9999;
            position: fixed; 
            top: 0; left: 0;
            display: none;

            #popupImage {
                position: fixed;
                top: 100px; left: 50%;
                z-index: 2;

                img { margin-left: -241px; } 

                area { cursor: pointer; }
            }

            #black-screen { 
                position: fixed; 
                top: 0; left: 0; 
                width: 100%; height: 100%; 
                background: #000; 
                opacity: 0.7; 
            }
        }

        #popup2 {
            z-index: 9999;
            position: fixed; 
            top: 0; left: 0;
            display: none;
            cursor: pointer;

            #popupImage2 {
                position: fixed;
                top: 100px; left: 50%;
                z-index: 2;

                img { margin-left: -325px; } 

                area { cursor: pointer; }
            }

            #black-screen2 { 
                position: fixed; 
                top: 0; left: 0; 
                width: 100%; height: 100%; 
                background: #000; 
                opacity: 0.7; 
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue